// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2YoAV","label":"Radio_label__1lJKl","checkMark":"Radio_checkMark__23hJq","disabled":"Radio_disabled__3dUJK"};